/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Profile_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_remove = /** @type {((inputs?: Profile_RemoveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_RemoveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Quitar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi")
	return /** @type {LocalizedString} */ ("Remove")
});